import { useMutation, useQuery } from "@tanstack/react-query";


import { uploadImageAPI } from "@src/api/raffle-draw";
import { getResultPageAPI, rafflePreviousResultAPI, raffleResultAPI, rewardsResultPageAPI } from "@src/api/rewards-management";
import { usePartnerDropdownContext } from "@src/context/PartnerDropdown";
import { useToasterContext } from "@src/context/Toaster";
import { UseDrawResultServiceOperators } from "@src/lib/types/draw-result-page";
import { AlertType } from "@src/lib/types/toaster";
import { useDrawResultContext } from "./provider";


export const useServices = (): Readonly<UseDrawResultServiceOperators> => {
  const { triggerOpen } = useToasterContext();
  const { state: { selectedPartnerId } } = usePartnerDropdownContext();
  const { state } = useDrawResultContext();
  const {
    page,
    order,
    orderBy,
    rowsPerPage,
    debouncedSearch,
  } = state || {};
  const newPage = (page || 0) + 1;

  const { data, isLoading } = useQuery({
    queryKey: ["result-page-content", {selectedPartnerId}],
    queryFn: async () => {
      const result = await getResultPageAPI({ partnerId: selectedPartnerId });

      return result;
    },
  });

  const { data: raffleResult } = useQuery({
    queryKey: ["raffle-results", { selectedPartnerId }],
    queryFn: async () => {
      const result = await raffleResultAPI({ partnerId: selectedPartnerId });
      return result.results;
    },
  });

  const { data: previousResult, isLoading: previousLoading, isRefetching: previousRefetching, refetch } = useQuery({
    queryKey: ["raffle-previous-results", { selectedPartnerId, newPage, order, orderBy, rowsPerPage, debouncedSearch }],
    queryFn: async () => {
      const reqParams: any = {
        pageSize: rowsPerPage,
        pageNumber: newPage,
        partnerId: selectedPartnerId
      };

      if (orderBy && order) reqParams.sort = `${orderBy},${order}`;
      if (debouncedSearch) reqParams.search = debouncedSearch;
      // if (todate) reqParams.to_date = todate;
      const result = await rafflePreviousResultAPI(reqParams);
      return result;
    },
  });

  // const { data: viewWinners, isLoading: viewLoading } = useQuery({
  //   queryKey: ["view-winner-results", { selectedPartnerId, newPage, order, orderBy, rowsPerPage, debouncedSearch }],
  //   queryFn: async () => {
  //     const reqParams: any = {
  //       pageSize: rowsPerPage,
  //       pageNumber: newPage,
  //       partnerId: selectedPartnerId
  //     };

  //     if (orderBy && order) reqParams.sort = `${orderBy},${order}`;
  //     if (debouncedSearch) reqParams.search = debouncedSearch;
  //     // if (todate) reqParams.to_date = todate;
  //     const result = await viewWinnerResultAPI(reqParams);
  //     return result;
  //   },
  // });

  // const onViewWinners = useMutation({
  //   mutationKey: ['view-winner-results', { selectedPartnerId}],
  //   mutationFn: async (params?: Partial<any>) => {
  //     const result = await viewWinnerResultAPI({ ...params, partnerId: selectedPartnerId });
  //     return result;
  //   },
  //   onError: (error) => {
  //     triggerOpen({
  //       type: AlertType.error,
  //       title: "Publish Content",
  //       message: "Failed to publish.",
  //     });
  //   },
  // });

  const onPublish = useMutation({
    mutationKey: ['publish-content', {selectedPartnerId}],
    mutationFn: async (params?: Partial<any>) => {
      const result = await rewardsResultPageAPI({ ...params, partnerId: selectedPartnerId });
      return result;
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Publish Content",
        message: "Failed to publish.",
      });
    },
  });

  const uploadImage = useMutation({
    mutationKey: ['upload-image'],
    mutationFn: async (params?: Partial<any>) => {
      const result = await uploadImageAPI(params);
      return {
        type: params?.get("type"),
        result: result?.data ?? {}
      };
    },
    onError: (error) => {
      triggerOpen({
        type: AlertType.error,
        title: "Uploading Image",
        message: "Failed to upload image.",
      });
    },
  });

  const onRefreshPrevious = () => {
      // handlePageChange(null, 0);
    refetch();
  };

  return {
    data,
    raffleResult: raffleResult ?? [],
    currentDraw: raffleResult?.[0] ?? {},
    lastweekDraw: raffleResult?.[1] ?? {},
    previousDraw: previousResult,
    previousLoading: previousRefetching || previousLoading,
    onRefreshPrevious,
    isLoading,
    uploadImage,
    onPublish
  };
};
